module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_TUBE SKID_RHD_THUMB.f108fb39.jpg";